export interface StatusInterface {
   orderingId: number;
   code: string;
   status: string;
   date: string;
   event: string;
   reason: string;
}

export class Status implements StatusInterface {
   orderingId: number;
   code: string;
   status: string;
   date: string;
   event: string;
   reason: string;

   constructor( s?: Status ) {
      this.orderingId = s.orderingId;
      this.code = s.code;
      this.status = s.status;
      this.date = s.date;
      this.event = s.event;
      this.reason = s.reason;
   }

   public toString = (): string => {
      return this.status + '◬' + this.date;
   }
}
